module.exports = __webpack_public_path__ + "img/en-mb-s4.d938090e.png";